import { MousePointer, Hash, Wifi, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const cards = [
  {
    icon: MousePointer,
    title: "Pick your plan online",
    body: "Browse and sign up in minutes — no store visits, no hold times, no hassle.",
  },
  {
    icon: Hash,
    title: "Keep your number or get a new one",
    body: "Bring your number with you or start fresh — switching is quick either way.",
  },
  {
    icon: Wifi,
    title: "Activate instantly",
    body: "Get connected the same day with eSIM or SIM — no waiting around.",
  },
  {
    icon: Clock,
    title: "Everything handled for you",
    body: "Start to finish — plan selected, number transferred, service on — in the time it takes to drink a coffee.",
  },
];

const SwitchingIsEasy = () => {
  return (
    <section
      className="w-full py-16 lg:py-24 border-t"
      style={{ backgroundColor: '#1e1e1e', borderColor: 'rgba(255,255,255,0.08)' }}
    >
      <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">

          {/* Left */}
          <div className="w-full lg:w-[420px] flex-shrink-0 flex flex-col justify-center">
            <p
              className="font-semibold uppercase mb-4"
              style={{ color: '#B0F18D', fontSize: '13px', letterSpacing: '0.15em' }}
            >
              Switching Is Easy
            </p>
            <h2
              className="text-white font-bold mb-6"
              style={{
                fontSize: 'clamp(32px, 4vw, 56px)',
                lineHeight: 1.1,
                letterSpacing: '-0.04em',
              }}
            >
              Switch in minutes. No store. No hold music.
            </h2>
            <p
              className="mb-8"
              style={{
                color: 'rgba(255,255,255,0.65)',
                fontSize: 'clamp(15px, 1.5vw, 18px)',
                lineHeight: 1.7,
              }}
            >
              Switching to Perch is fast, fully online, and built for how you actually want to sign up — no stores, no waiting, no friction.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/plans">
                <button
                  className="font-semibold rounded-full px-7 h-[48px]"
                  style={{ backgroundColor: '#B0F18D', color: '#000000', fontSize: '15px' }}
                >
                  Switch to Perch
                </button>
              </Link>
              <Link to="/faq">
                <button
                  className="font-semibold rounded-full px-7 h-[48px] border"
                  style={{
                    backgroundColor: 'transparent',
                    color: 'rgba(255,255,255,0.75)',
                    borderColor: 'rgba(255,255,255,0.2)',
                    fontSize: '15px',
                  }}
                >
                  Have questions?
                </button>
              </Link>
            </div>
          </div>

          {/* Right: Cards */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {cards.map(({ icon: Icon, title, body }) => (
              <div
                key={title}
                className="flex flex-col p-6 rounded-2xl border"
                style={{
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderColor: 'rgba(255,255,255,0.1)',
                }}
              >
                <div
                  className="flex items-center justify-center w-10 h-10 rounded-xl mb-4 flex-shrink-0"
                  style={{ backgroundColor: 'rgba(176,241,141,0.12)' }}
                >
                  <Icon className="w-5 h-5" style={{ color: '#B0F18D' }} />
                </div>
                <h3
                  className="text-white font-bold mb-2"
                  style={{ fontSize: '16px', letterSpacing: '-0.02em' }}
                >
                  {title}
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: 1.6 }}>
                  {body}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default SwitchingIsEasy;
